// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__0KuOZ","light":"Label_light__nRZ84"};